import { reatomNumber } from "@reatom/primitives";
import { withSearchParamsPersist } from "@reatom/url";

export const pageAtom = reatomNumber(1, "pageAtom").pipe(
  withSearchParamsPersist(
    "page",
    (v?: string) => (v ? Number(v) : 1),
    (v: number | undefined) => (v ? String(v) : "1"),
  ),
);

export const perPageAtom = reatomNumber(20, "perPageAtom").pipe(
  withSearchParamsPersist(
    "perPage",
    (v?: string) => (v ? Number(v) : 20),
    (v: number | undefined) => (v ? String(v) : "20"),
  ),
);
